export default "__VITE_ASSET__C32J2X1g__"